import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import AlertCircleIcon from '@/assets/icons/alert-circle.svg?react'
import CrossIcon from '@/assets/icons/cross.svg?react'
import { Trans } from '@/components/Trans'

const DISMISS_STORAGE_KEY = 'subscription_credit_alert_dismissed'

function wasDismissed() {
  try {
    return localStorage.getItem(DISMISS_STORAGE_KEY) === 'true'
  } catch {
    return false
  }
}

export function SubscriptionCreditAlert() {
  const { t } = useTranslation()
  const [dismissed, setDismissed] = useState(wasDismissed)

  if (dismissed) return null

  return (
    <div
      className="w-full flex items-center gap-4 p-4 rounded-lg border border-warning/60 bg-warning/10"
      data-ai-component="subscription-credit-alert"
    >
      <AlertCircleIcon className="w-5 h-5 shrink-0 text-warning" />
      <div className="flex-1 t-sm text-warning">
        <Trans i18nKey="create.subscriptionCreditAlert">
          Subscription uses Recharged Credits only. Other credit types can only be used for
          pay-as-you-go.
        </Trans>
      </div>
      <button
        type="button"
        className="shrink-0 text-secondary"
        onClick={() => {
          try {
            localStorage.setItem(DISMISS_STORAGE_KEY, 'true')
          } catch {
            // The alert can still be dismissed for this session when storage is unavailable.
          }
          setDismissed(true)
        }}
        aria-label={t('common.dismiss')}
      >
        <CrossIcon className="w-4 h-4" />
      </button>
    </div>
  )
}
